module.exports = __webpack_public_path__ + "assets/img/C1.f261c744.jpg";